import React, {PropTypes} from "react";
import {connect} from "react-redux";
import EmployeeTable from "./components/EmployeeTable";
import axios from "axios";
import RaisedButton from "material-ui/RaisedButton";
import ModalExit from "./components/Modal";
import ModalView from "./components/ModalView";
import ModalEdit from "./components/ModalEdit";
import Dialog from "material-ui/Dialog";
import EmployeeSS from "../../../components/joiningForm/EmployeeSS";
import csvConvert from "../../../classes/csvConvert";
import Auth from "../../../redux/actions/Authentication/auth.class.js";

class PeopleSearchHome extends React.Component {

  constructor() {
    super();
    this.state = {
      employee: null, employees: [], loading: 0, open: false, openExit: false, openEdit: false, pFlag: false,
      selected: null,
      joiningDialog: false,
      editAccountNumber: ""
    };
    this.openComplete = this.openComplete.bind(this);
    this.openEdit = this.openEdit.bind(this);
    this.closeEdit = this.closeEdit.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.openExit = this.openExit.bind(this);
    this.closeExit = this.closeExit.bind(this);
    this.edit = this.edit.bind(this);
    this.downloadCsv = this.downloadCsv.bind(this);
    this.editDetails = this.editDetails.bind(this);
  }

  editDetails(emp){
    if(emp == Auth.EmpId){
      this.setState({editAccountNumber: "true"});
    }
    else{
      this.setState({editAccountNumber: "false"});
    }
  }

  openComplete(emp) {
    this.editDetails(emp);
    this.setState({joiningDialog: true, selected: {empno: emp}});
  }

  openEdit() {
    this.setState({openEdit: true});
  }

  closeEdit() {
    this.setState({openEdit: false});
  }

  openDialog() {
    this.setState({open: true})
  }

  closeDialog() {
    this.setState({open: false})
  }

  openExit() {
    this.setState({openExit: true});
  }

  closeExit() {
    this.setState({openExit: false})
  }

  edit(employee) {
    this.setState({employee: employee})
  }

  componentDidMount() {
    this.props.changeBanner("HR Admin")
  }

  downloadCsv(dump) {
    let csvContent = new csvConvert();


    let tableData = csvContent.convertArrayOfAnyObjectsToCSV({data: dump});
    console.log(tableData);

    let blob = new Blob([tableData], {type: "text/csv;charset=utf-8;"});
    blob = window.webkitURL.createObjectURL(blob);
    let getCsv = new Promise((resolve, reject)=> {
      this.setState({csv: blob});
      resolve(true);
    });
    getCsv.then((response)=> {
      this.download.click();
    })
  }

  render() {
    const actionDecline = [
      <RaisedButton
        label="Cancel"
        secondary={true}
        onTouchTap={()=> {
          this.setState({joiningDialog: false})
        }}
      />];

    return (
      <div>
        {this.state.employee == null ? null :
          <div>
            <ModalExit open={this.state.openExit}
                       employee={this.state.employee}
                       close={this.closeExit}
                       refresh={this.props.refresh}
                       url="/applyExit"
            />
          </div>
        }
        {this.state.open ?
          <div>
            <ModalView open={this.state.open}
                       display="inline"
                       employee={this.state.employee}
                       close={this.closeDialog}
                       refresh={this.props.refresh}
            />
          </div> : null
        }
        {this.state.openEdit ? <div>
          <ModalEdit open={this.state.openEdit}
                     employee={this.state.employee}
                     close={this.closeEdit}
                     refresh={this.props.refresh}
                     employees={this.props.activeEmployees}
                     constants={this.props.constants}
          />
        </div> : null}
        <a href={this.state.csv} download={"Employee_Personal_Details.csv"} ref={(input) => {
          this.download = input;
        }}/>

        <RaisedButton
          onClick={()=> {
            axios.get(process.env.REQ_URL + "/aboutEmpPersonalDetails?q=all", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
              this.downloadCsv(response.data.data);
            }).catch((error)=> {
            });
          }}
          primary={this.state.pFlag} className="btn btn-default">Download Personal Details</RaisedButton>

        <Dialog
          title="Joiner Details"
          actions={actionDecline}
          contentStyle={{height: "60%", maxWidth: 'none', width: '80%'}}
          autoScrollBodyContent={true}
          autoDetectWindowHeight={true}
          width="80%"
          modal={false}
          onRequestClose={()=> {
            this.setState({joiningDialog: false})
          }}
          open={this.state.joiningDialog}
        >
          <div style={{"font-family": '"Roboto", "sans-serif"'}}>
            <EmployeeSS changeBanner={(name)=> {
              return null;
            }} showAll={false} employee={this.state.selected} editAccount={this.state.editAccountNumber}/>
          </div>
        </Dialog>


        <EmployeeTable
          openComplete={this.openComplete}
          edit={this.edit}
          openView={this.openDialog}
          openEdit={this.openEdit}
          openExit={this.openExit}
          constants={this.props.constants}
          employees={this.props.employees}/>
      </div>
    );
  }

}

PeopleSearchHome.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    activeEmployees: state.employees
  };

}


export default connect(mapStateToProps)(PeopleSearchHome);




/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/PeopleSearch/PeopleSearchHome.js
 **/